import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { usePageTitle } from '../layouts/PageTitleContext';
import useBreadcrumbSetup from '../components/useBreadcrumbSetup';
import AppointmentsCalendar from '../components/Calendar/AppointmentsCalendar';

const Appointements = () => {
	const { t } = useTranslation();
	const { setTitle, setTitleIcon } = usePageTitle();

	useEffect(() => {
	    setTitle(`${t('Calendar')}<span style="display:block;font-size:11px;font-weight:400;color:#9ca3af;margin-top:5px;">Rendez-vous et planning</span>`);
	    document.title = t('Calendar');
	    setTitleIcon('ti-calendar');
	    return () => setTitleIcon(null);
	}, [setTitle, setTitleIcon, t]);

	useBreadcrumbSetup([
	    { label: t('Calendar'), url: "/appointements" },
	]);

	return (
		<div className="page-content page-content--calendar">
			<AppointmentsCalendar />
		</div>
	)
};

export default Appointements;